








import Vue from 'vue';

const clickHandler = function(ev) {
  ev.preventDefault();
  ev.stopPropagation();
  // This is the only way I found to make it work :/
  ev.currentTarget.parentNode.classList.toggle('is-expanded');
};

export default Vue.extend({
  name: 'ZenEllipsis',
  functional: true,
  // In order to make this component functional aka. faster to render, it had
  // to be changed to use the render function, because the template version
  // doesn't have support for methods
  render(h, ctx) {
    const { listeners } = ctx;
    return h(
      'div',
      {
        class: {
          'text-ellipsis': true,
        },
      },
      [
        h(
          'div',
          {
            class: 'content',
          },
          ctx.slots().default
        ),
        h('a', {
          attrs: {
            href: '#',
          },
          class: 'ellipsis-toggle',
          on: {
            click(event) {
              clickHandler(event);
              const toggle = listeners.toggle;
              if (toggle) {
                toggle(event);
              }
            },
          },
        }),
      ]
    );
  },
});
